////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const statistics = {
	resetStatistics: () => ({
		type: ActionsTypes.RESET_STATISTICS,
	}),
	getStatistics: (kioskId, dateStart, dateEnd) => ({
		type: ActionsTypes.GET_STATISTICS,
		payload: {
			kioskId,
			dateStart,
			dateEnd,
		}
	}),
	getStatisticsSuccess: (data) => ({
		type: ActionsTypes.GET_STATISTICS_SUCCESS,
		payload: {
			data
		}
	}),
	getStatisticsError: (error) => ({
		type: ActionsTypes.GET_STATISTICS_ERROR,
		payload: {
			error
		}
	}),
	exportStatistics: () => ({
		type: ActionsTypes.EXPORT_STATISTICS,
	}),
	exportStatisticsSuccess: (data) => ({
		type: ActionsTypes.EXPORT_STATISTICS_SUCCESS,
		payload: {
			data
		}
	}),
	exportStatisticsError: (error) => ({
		type: ActionsTypes.EXPORT_STATISTICS_ERROR,
		payload: {
			error
		}
	})
}

export default statistics